module.exports = __webpack_public_path__ + "static/media/pic-abend-kompakt-1.3ef42775.jpg";